import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = {
    createUser: (session_id, referred_by) =>
        axios.post(`${API}/users`, { session_id, referred_by }).then(r => r.data),
    getUser: (session_id) =>
        axios.get(`${API}/users/${session_id}`).then(r => r.data),
    submitScore: (session_id, answers) =>
        axios.post(`${API}/users/${session_id}/score`, { answers }).then(r => r.data),
    saveQuizProgress: (session_id, answers, idx) =>
        axios.put(`${API}/users/${session_id}/quiz-progress`, { answers, idx }).then(r => r.data),
    unlock: (session_id, method) =>
        axios.post(`${API}/users/${session_id}/unlock`, { method }).then(r => r.data),
    getArchetype: (id) =>
        axios.get(`${API}/archetypes/${id}`).then(r => r.data),
    createReferral: (referral_code, referred_session_id) =>
        axios.post(`${API}/referrals`, { referral_code, referred_session_id }).then(r => r.data),
    referralCount: (code) =>
        axios.get(`${API}/referrals/count/${code}`).then(r => r.data),
    mockCheckout: (session_id, plan, accepted_terms = false) =>
        axios.post(`${API}/checkout/mock`, { session_id, plan, accepted_terms }).then(r => r.data),
    createCheckout: (session_id, origin_url) =>
        axios.post(`${API}/payments/checkout`, { session_id, origin_url }).then(r => r.data),
    paymentStatus: (checkout_session_id) =>
        axios.get(`${API}/payments/status/${checkout_session_id}`).then(r => r.data),
    getReceipt: (session_id) =>
        axios.get(`${API}/payments/receipt/${session_id}`).then(r => r.data),
    geoSuggest: (q) =>
        axios.get(`${API}/geo/suggest`, { params: { q } }).then(r => r.data),
    geoIp: () =>
        axios.get(`${API}/geo/ip`).then(r => r.data),
    marketStanding: (session_id) =>
        axios.get(`${API}/markets/standing/${session_id}`).then(r => r.data),
    saveLocation: (session_id, loc) =>
        axios.put(`${API}/users/${session_id}/location`, { city: loc.city, state: loc.state }).then(r => r.data),
    captureEmail: (session_id, email) =>
        axios.post(`${API}/users/${session_id}/email`, { email }).then(r => r.data),
    listNotifications: (session_id) =>
        axios.get(`${API}/users/${session_id}/notifications`).then(r => r.data),
    notificationsUnread: (session_id) =>
        axios.get(`${API}/users/${session_id}/notifications/unread-count`).then(r => r.data),
    markNotificationRead: (session_id, notif_id) =>
        axios.post(`${API}/users/${session_id}/notifications/${notif_id}/read`).then(r => r.data),
    markAllNotificationsRead: (session_id) =>
        axios.post(`${API}/users/${session_id}/notifications/read-all`).then(r => r.data),
    foundingStats: () =>
        axios.get(`${API}/founding/stats`).then(r => r.data),
    saveProfile: (session_id, payload) =>
        axios.post(`${API}/users/${session_id}/profile`, payload).then(r => r.data),
    getProfile: (session_id) =>
        axios.get(`${API}/users/${session_id}/profile`).then(r => r.data),
    uploadPhoto: (session_id, file) => {
        const fd = new FormData();
        fd.append("file", file);
        return axios.post(`${API}/users/${session_id}/photos`, fd).then(r => r.data);
    },
    uploadLivePhoto: (session_id, blob) => {
        const fd = new FormData();
        fd.append("file", blob, "live.jpg");
        return axios.post(`${API}/users/${session_id}/live-photo`, fd).then(r => r.data);
    },
    uploadVideo: (session_id, blob, prompt) => {
        const fd = new FormData();
        fd.append("file", blob, "video.webm");
        fd.append("prompt", prompt);
        return axios.post(`${API}/users/${session_id}/video`, fd).then(r => r.data);
    },
    deletePhoto: (session_id, photo_id) =>
        axios.delete(`${API}/users/${session_id}/photos/${photo_id}`).then(r => r.data),
    videoPrompts: () =>
        axios.get(`${API}/video-prompts`).then(r => r.data),
    matches: (session_id) =>
        axios.get(`${API}/matches`, { params: { session_id } }).then(r => r.data),
    publicProfile: (public_id, viewer_session_id) =>
        axios.get(`${API}/profile/public/${public_id}`, { params: { viewer_session_id } }).then(r => r.data),
    submitFeedback: (payload) =>
        axios.post(`${API}/feedback`, payload).then(r => r.data),
    weeklyPicks: (session_id) =>
        axios.get(`${API}/weekly-picks`, { params: { session_id } }).then(r => r.data),
    aiHistory: (session_id, mode) =>
        axios.get(`${API}/ai/history`, { params: { session_id, mode } }).then(r => r.data),
    aiChat: (session_id, mode, message) =>
        axios.post(`${API}/ai/chat`, { session_id, mode, message }).then(r => r.data),
    aiClearHistory: (session_id, mode) =>
        axios.delete(`${API}/ai/history`, { params: { session_id, mode } }).then(r => r.data),
    redeemCode: (session_id, code) =>
        axios.post(`${API}/redeem-code`, { session_id, code }).then(r => r.data),
    acceptTerms: (session_id, context = "signup", version = "v1-2026-02") =>
        axios.post(`${API}/users/${session_id}/accept-terms`, { session_id, context, version }).then(r => r.data),
    voiceStatus: () => axios.get(`${API}/voice/status`).then(r => r.data),
    transcribe: (session_id, blob, ext = "webm") => {
        const fd = new FormData();
        fd.append("session_id", session_id);
        fd.append("file", blob, `voice.${ext}`);
        return axios.post(`${API}/voice/transcribe`, fd).then(r => r.data);
    },
    tts: (session_id, text) =>
        axios.post(`${API}/voice/tts`, { session_id, text }, { responseType: "blob" }).then(r => r.data),
    researchStatus: () => axios.get(`${API}/research/status`).then(r => r.data),
    dateIdeas: (session_id, vibe) =>
        axios.post(`${API}/research/date-ideas`, { session_id, vibe }).then(r => r.data),
    paypalConfig: () => axios.get(`${API}/paypal/config`).then(r => r.data),
    paypalCreateOrder: (session_id) =>
        axios.post(`${API}/paypal/orders`, { session_id }).then(r => r.data),
    paypalCapture: (order_id, session_id) =>
        axios.post(`${API}/paypal/orders/${order_id}/capture`, { session_id }).then(r => r.data),
    tiers: () => axios.get(`${API}/tiers`).then(r => r.data),
    joinWaitlist: (payload) => axios.post(`${API}/waitlist/join`, payload).then(r => r.data),
    myWaitlist: (session_id) =>
        axios.get(`${API}/waitlist/me`, { params: { session_id } }).then(r => r.data),

    // ----- Phase 2: Date Planning Flow -----
    dating: {
        venues: (city) => axios.get(`${API}/dating/venues`, { params: city ? { city } : {} }).then(r => r.data),
        listMatches: (session_id) =>
            axios.get(`${API}/dating/matches`, { params: { session_id } }).then(r => r.data),
        getMatch: (match_id, session_id) =>
            axios.get(`${API}/dating/matches/${match_id}`, { params: { session_id } }).then(r => r.data),
        submitAvailability: (match_id, user_id, windows) =>
            axios.post(`${API}/dating/matches/${match_id}/availability`, { user_id, windows }).then(r => r.data),
        venueSuggestions: (match_id, window_key, session_id) =>
            axios.get(`${API}/dating/matches/${match_id}/venue-suggestions`,
                { params: { window_key, session_id } }).then(r => r.data),
        proposeDate: (match_id, user_id, window, venue_id) =>
            axios.post(`${API}/dating/matches/${match_id}/propose`, { user_id, window, venue_id }).then(r => r.data),
        confirmDate: (match_id, user_id) =>
            axios.post(`${API}/dating/matches/${match_id}/confirm`, { user_id }).then(r => r.data),
        cancelDate: (date_id, user_id) =>
            axios.post(`${API}/dating/dates/${date_id}/cancel`, { user_id }).then(r => r.data),
        icsUrl: (date_id, session_id) =>
            `${API}/dating/dates/${date_id}/ics?session_id=${encodeURIComponent(session_id)}`,
        listMessages: (match_id, session_id) =>
            axios.get(`${API}/dating/matches/${match_id}/messages`, { params: { session_id } }).then(r => r.data),
        sendMessage: (match_id, sender_user_id, body) =>
            axios.post(`${API}/dating/matches/${match_id}/messages`, { sender_user_id, body }).then(r => r.data),
        briefing: (date_id, session_id) =>
            axios.get(`${API}/dating/dates/${date_id}/briefing`, { params: { session_id } }).then(r => r.data),
        submitCheckin: (date_id, payload) =>
            axios.post(`${API}/dating/dates/${date_id}/checkin`, payload).then(r => r.data),
        createTestMatch: (session_id) =>
            axios.post(`${API}/dating/test-match/${session_id}`).then(r => r.data),
    },
};

export function fileUrl(pathOrUrl) {
    if (!pathOrUrl) return null;
    if (pathOrUrl.startsWith("http")) return pathOrUrl;
    if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
    return `${BACKEND_URL}/api/files/${pathOrUrl}`;
}
